import React, { useState, useEffect } from "react";
import { Button, RadioButton } from "../../../common/commonIndex";
import { useSearchParams } from "react-router-dom";

const Colonoscopy = ({ handleNextEvent, formData, questionData, questionnairelist }) => {
    const gender = ['Yes', 'No'];
    const [colonoscopy, setColonoscopy] = useState(formData?.answer || "");
    const [nestedIndex, setNestedIndex] = useState(null);
    const [isValid, setIsValid] = useState(false);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (formData?.answer) {
            handleSetSkipQuestionIndex(formData.answer);
            setColonoscopy(formData.answer);
            setIsValid(true);
        } else {
            setColonoscopy('');
            setIsValid(false);
        }
    });

    const handleSetSkipQuestionIndex = (value) => {
        let sliceArray = questionnairelist?.slice(1, -1);
        const currentIndex = parseInt(searchParams.get('step')); // Get the current index
        const idKey = value?.toLowerCase() === 'yes' ? 'nextQuestionID' : 'skippedNestedQuestionID';

        // Get the target ID based on the condition
        const targetID = sliceArray[currentIndex - 1]?.[idKey];

        // Find the nested index
        const nestedIndex = sliceArray?.findIndex((element) => element.id === targetID);
        
        // Set the nested index and store it in localStorage
        setNestedIndex(nestedIndex);
        localStorage.setItem('skippedQuestionIndex', JSON.stringify(nestedIndex));

    }

    /* Callback function to handle radio button change */
    const handleRadioChange = (value) => {
        handleSetSkipQuestionIndex(value);
        setColonoscopy(value);
        setIsValid(true);
        formData.answer = value;
        formData.fkAnswerIds = value;
    };

    /* Submit */
    const handleSubmit = (e) => {
        let skip = 1;
        const findData = getLocalStorageData();
        findData[questionData.questionerIndex] = formData;
        setLocalStorageData(findData);
        if(nestedIndex > 0 && formData?.answer?.toLowerCase() === 'no'){
            handleNextEvent(nestedIndex + skip);
        }else{
            handleNextEvent(questionData?.questionerIndex + skip);
        }
    };

    const getLocalStorageData = () => {
        const findlocalStorageData = JSON.parse(localStorage.getItem('listOfAnswer'));
        return findlocalStorageData;
    }
    const setLocalStorageData = (data) => {
        if (data?.length > 0) {
            localStorage.setItem('listOfAnswer', JSON.stringify(data));
        }
    }

    return (
        <>
            <div className="email-form-container">
                <h2 className="title" style={{ marginBottom: "52px" }}>{questionData.question}</h2>
                <form>
                    <div className="list colonoscopy-radio mb-5">
                        {gender?.map((item, index) => {
                            const isSelected = colonoscopy === item;
                            const className = isSelected ? "list-item selected selected" : "list-item selected";
                            return (
                                <div className={className} key={index}>
                                    <RadioButton
                                        radioButton="gender"
                                        name={item}
                                        id={index}
                                        onRadioChange={handleRadioChange}
                                        formData={formData}
                                        value={colonoscopy}
                                        setValue={setColonoscopy}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </form>
            </div>
            <div className="questionnaire-fix-btn eligibility-fix-btn">
                <div className="divider "></div>
                <div className="footer-content">
                    <div className="skip-eligibility">
                    </div>
                    <Button
                        btnClass={'btn-primary question-btn'}
                        btnType={'button'}
                        btnName={'Continue'}
                        onClick={handleSubmit}
                        isDisabled={isValid}
                    />
                </div>
            </div>
        </>
    )
};

export default Colonoscopy;